import { createGlobalStyle } from "styled-components";
import { COLORS } from "../constants/colors/colors";
import { FontSizeSetting, getFontMultiplier } from "../utils/fontUtils";

interface GlobalStyleProps {
  fontSize: FontSizeSetting;
}

export const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: ${({ fontSize }) => {
      const multiplier = getFontMultiplier(fontSize);
      return `${multiplier * 16}px`;
    }};
    overflow-x: hidden;
    overflow-x: clip;
    width: 100%;

    @media (max-width: 480px) {
      font-size: ${({ fontSize }) => {
        const multiplier = getFontMultiplier(fontSize);
        return `${multiplier * 16 - 2}px`;
      }};
    }
  }

  body {
    color: ${COLORS.IMMERSIVE_BLUE_DARK};
    font-family: 'Montserrat', sans-serif;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    overflow-x: clip;
    width: 100%;
    max-width: 100vw;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
    font-size: inherit;
    font-style: inherit;
    font-weight: inherit;
    color: inherit;
    line-height: inherit;
  }

  input, textarea {
    outline: none;
    font-family: inherit;
    font-size: inherit;
    font-style: inherit;
    font-weight: inherit;
    color: inherit;
    line-height: inherit;
  }
`;
